<template>
  <b-card
    class="m-2"
  >
    <!--    <div class="row mb-2">
      <div class="d-flex justify-content-between flex-column col-xl-12 col-21">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ universityProfile.unv_name }}
              </h4>
            </div>
          </div>
          <div class="d-flex flex-column text-center">
            <b-img
              :width="imgWidth"
              src="@/assets/images/logo/wtu-logo4.jpg"
            />
          </div>
        </div>
      </div>
    </div>-->
    <div class="row mb-1">
      <div class="col-xl-12 col-12 text-center">
        <b-img
          :width="imgWidth"
          src="@/assets/images/logo/wtu-logo4.jpg"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-12 text-center">
        <h4 class="mb-0">
          {{ universityProfile.unv_name }}
        </h4>
      </div>
    </div>

    <div class="divider">
      <div class="divider-text">
        <!--        {{ title }}-->
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12 col-12 text-center">
        <h4 class="mb-1">
          {{ title }}
        </h4>
      </div>
    </div>

    <div
      v-if="profile.code"
      class="row"
    >
      <div class="d-flex justify-content-between flex-column col-xl-6 col-21">
        <div class="d-flex justify-content-start align-items-center">
          <b-avatar
            rounded
            size="110px"
            :src="profilePicture"
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h5 class="mb-0">
                {{ profile.code }}
              </h5>
              <b-card-text>{{ profile.preName }} {{ profile.name }} {{ profile.surname }}</b-card-text>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-12">
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">วิทยาเขต</span></th>
            <td class="pb-50">
              {{ profile.campusName }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">คณะ</span></th>
            <td class="pb-50 text-capitalize">
              {{ profile.divisionName }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">สาขา</span></th>
            <td class="pb-50 text-capitalize">
              {{ profile.departmentName }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">วันเกิด</span></th>
            <td class="pb-50">
              {{ profile.birthDateTh }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">อายุ</span></th>
            <td class="pb-50">
              {{ profile.age }} ปี
            </td>
          </tr>
          <tr>
            <th>
              <span class="font-weight-bold">หมู่โลหิต</span></th>
            <td>
              {{ profile.bloodGroup }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div class="col-xl-12 col-12 text-center">
        <h4>ไม่พบข้อมูล</h4>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BCardText, BImg,
} from 'bootstrap-vue'
import axios from 'axios'
import { westernAPIServer, nationAPIServer } from '@/constants/config'

export default {
  name: 'QrInfo',
  components: {
    BCard,
    BAvatar,
    BCardText,
    BImg,
  },
  data() {
    return {
      universityProfile: {
        unv_name: '',
      },
      profile: {
        preName: '',
        code: '',
        name: '',
        surname: '',
        campusName: '',
        divisionName: '',
        departmentName: '',
        birthDateTh: '',
        birthDate: '',
        bloodGroup: '',
        age: '',
      },
      type: '',
      photoFolder: '',
      title: '',
      imgWidth: '70px',
      universityLog: '@/assets/images/logo/wtu-logo4.jpg',
    }
  },
  computed: {
    profilePicture() {
      if (this.profile?.code) {
        const apiUrl = this.getApiUrl()
        return `${apiUrl}/${this.photoFolder}/${this.profile?.code}`
      }
      return ''
    },
  },
  async beforeMount() {
    if (this.$route.params && this.$route.params.type && this.$route.params.id) {
      this.setType()
      await this.loadData()
    } else {
      await this.$router.push('error-404')
    }
  },
  methods: {
    getApiUrl() {
      const url = window.location.href
      if (url.includes('western')) {
        this.imgWidth = '70px'
        this.universityLog = '@/assets/images/logo/wtu-logo4.jpg'
        return westernAPIServer
      }
      if (url.includes('nation')) {
        this.imgWidth = '110px'
        this.universityLog = '@/assets/images/logo/ntu-logo4.jpg'
        return nationAPIServer
      }
      return westernAPIServer
    },
    async loadData() {
      const apiUrl = this.getApiUrl()
      const result = await axios({
        url: `${apiUrl}/admin/wems_api/get_qr_person_info`,
        method: 'post',
        data: {
          type: this.$route.params.type,
          id: this.$route.params.id,
        },
      })

      if (result?.status === 200 && result?.data) {
        this.profile = result.data
        this.universityProfile = result.data.SM_PROFILE
      }
    },
    setType() {
      if (this.$route.params.type === 'STD') {
        this.title = 'ข้อมูลนิสิต'
        this.type = 'student'
        this.photoFolder = 'stdphoto'
      } else if (this.$route.params.type === 'EMP') {
        this.title = 'ข้อมูลเจ้าหน้าที่'
        this.type = 'admin'
        this.photoFolder = 'staffphoto'
      } else if (this.$route.params.type === 'TCH') {
        this.title = 'ข้อมูลอาจารย์'
        this.type = 'teacher'
        this.photoFolder = 'staffphoto'
      }
    },
  },
}
</script>

<style scoped>

</style>
